export const MenuConstant = [
    {
        "id": 1,
        "title": "ra.sideMenu.home",
        "name": "首页",
        "url": "/",
        "icon": "HomeIcon",
        "children": []
    },
    {

        "id": 2,
        "title": 'ra.sideMenu.trafficSales.title',
        "name": "流量销售",
        "url": "",
        "icon": "CastIcon",
        "children": [
            {
                "id": 21,
                "title": 'ra.sideMenu.trafficSales.addUser',
                "name": "账号管理",
                "permission": ['admin', 'ops'],
                "url": "/trafficAccount",
                "icon": "",
                "children": []
            },
            {
                "id": 22,
                "title": 'ra.sideMenu.trafficSales.runningVolume',
                "name": "流量管理",
                "url": "",
                "icon": "DirectionsRunIcon",
                "children": [
                    {
                        "id": 221,
                        "title": 'ra.sideMenu.trafficSales.strategy',
                        "name": "流量策略设定",
                        "url": "/strategy",
                        "permission": ['admin', 'ops'],
                        "icon": "",
                        "children": []
                    },
                    {
                        "id": 222,
                        "title": 'ra.sideMenu.trafficSales.deploy',
                        "name": "流量部署",
                        "permission": ['admin', 'ops'],
                        "url": "/deploy",
                        "icon": "",
                        "children": []
                    },
                    {
                        "id": 225,
                        "title": 'ra.sideMenu.trafficSales.wxSnManage',
                        "name": "网心SN管理",
                        "permission": ['admin', 'ops'],
                        "url": "/xunleiSnManage",
                        "icon": "",
                        "children": []
                    },
                    {
                        "id": 224,
                        "title": 'ra.sideMenu.trafficSales.wxDeploy',
                        "name": "网心流量部署",
                        "permission": ['admin', 'ops'],
                        "url": "/xunleiDeploy",
                        "icon": "",
                        "children": []
                    },

                    {
                        "id": 223,
                        "title": 'ra.sideMenu.trafficSales.equipmentDetails',
                        "name": "流量设备明细",
                        "permission": ['admin', 'ops'],
                        "url": "/equipmentDetails",
                        "icon": "",
                        "children": []
                    },
                ]
            },
            {
                "id": 25,
                "title": 'ra.sideMenu.trafficSales.trafficRevenue',
                "name": "权益管理",
                "permission": ['admin', 'finance'],
                "url": "/trafficRevenue",
                "icon": "",
                "children": []
            },
        ]
    },
    {
        "id": 3,
        "title": 'ra.sideMenu.equipmentSales.title',
        "name": "设备销售",
        "url": "",
        "icon": "DisplaySettingsIcon",
        "children": [
            {
                "id": 31,
                "title": 'ra.sideMenu.equipmentSales.deviceAccount',
                "name": "账号管理",
                "permission": ['admin', 'ops'],
                "url": "/deviceAccount",
                "icon": "",
                "children": []
            },
            {
                "id": 32,
                "title": 'ra.sideMenu.equipmentSales.equipment',
                "name": "设备管理",
                "permission": ['admin', 'ops'],
                "url": "/equipment",
                "icon": "",
                "children": []
            },
            {
                "id": 33,
                "title": 'ra.sideMenu.equipmentSales.otaUpgrade',
                "name": "系统升级",
                "permission": ['admin', 'ops'],
                "url": "/otaUpgrade",
                "icon": "",
                "children": []
            },
            {
                "id": 35,
                "title": 'ra.sideMenu.equipmentSales.upgradeSystem',
                "name": "系统包管理",
                "permission": ['admin', 'ops'],
                "url": "/upgradeSystem",
                "icon": "",
                "children": []
            },
            {
                "id": 34,
                "title": 'ra.sideMenu.equipmentSales.deviceRevenue',
                "name": "权益管理",
                "permission": ['admin', 'finance'],
                "url": "/deviceRevenue",
                "icon": "",
                "children": []
            },
            {
                "id": 36,
                "title": 'ra.sideMenu.equipmentSales.financeManage',
                "name": "财务管理",
                "url": "/financeManage",
                "icon": "CreditCard",
                "children": [
                    {
                        "id": 361,
                        "title": '对账管理',
                        "name": "对账管理",
                        "permission": ['admin', 'finance'],
                        "url": "/reconciliation",
                        "icon": "",
                        "children": []
                    },
                    {
                        "id": 362,
                        "title": '提现管理',
                        "name": "提现管理",
                        "permission": ['admin', 'finance'],
                        "url": "/withdrawal",
                        "icon": "",
                        "children": []
                    }
                ]
            },
        ]
    },
    {

        "id": 4,
        "title": 'ra.sideMenu.factory.title',
        "name": "工厂端",
        "url": "",
        "icon": "PrecisionManufacturingIcon",
        "children": [
            {
                "id": 41,
                "title": 'ra.sideMenu.factory.storeProduct',
                "name": "产品入库",
                "permission": ['admin', 'ops', 'factory'],
                "url": "/storeProduct",
                "icon": "",
                "children": []
            },
            {
                "id": 42,
                "title": 'ra.sideMenu.factory.outboundProduct',
                "name": "产品出库",
                "permission": ['admin', 'ops'],
                "url": "/outboundProduct",
                "icon": "",
                "children": []
            },
            {
                "id": 42,
                "title": 'ra.sideMenu.factory.outboundQueryList',
                "name": "出库查询",
                "permission": ['admin', 'ops'],
                "url": "/outboundQueryList",
                "icon": "",
                "children": []
            },
            {
                "id": 43,
                "title": 'ra.sideMenu.factory.factoryTesting',
                "name": "序列号管理",
                "permission": ['admin', 'ops'],
                "url": "/factoryTesting",
                "icon": "",
                "children": []
            },
            {
                "id": 44,
                "title": 'ra.sideMenu.factory.MACAddress',
                "name": "MAC地址管理",
                "permission": ['admin', 'ops'],
                "url": "/MACAddress",
                "icon": "",
                "children": []
            }
        ]
    },
];
